// The narrowest a share bar is drawn, in percent: a row with a little still
// shows a sliver, so it never reads as a row with nothing.
export const MIN_BAR_PERCENT = 2

// The CSS width of a bar that draws `value` against `max`: never past full,
// never under the sliver, and empty only when there is nothing to draw
// against.
export function barWidth(value, max = 1) {
  if (!(max > 0)) return '0%'
  const share = Math.min(1, Math.max(0, (Number(value) || 0) / max))
  return `${Math.max(MIN_BAR_PERCENT, share * 100)}%`
}
